import React, { useState, useEffect } from "react";

export const svg = `<svg width="20" height="20" viewbox="0 0 20 20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M9.84609 5.49142L7.84609 3.49142H4.98895L2.24609 6.23428H5.32038L5.86895 5.69714C6.38324 5.18285 6.42895 5.17142 6.61181 5.35428C6.80609 5.53714 6.70324 5.66285 4.70324 7.66285L2.58895 9.77714H11.7432L13.3204 8.17714L14.1318 8.97714L14.9432 9.78857L17.8461 9.72L15.6518 7.54857L15.9604 8.17714C16.1318 8.52 16.2461 8.78285 16.2118 8.74857C16.1775 8.71428 15.8118 8.27999 15.4004 7.77714L14.6575 6.86285L16.3375 5.17142L18.0175 3.49142H14.9318L14.109 4.31428L13.2747 5.13714L12.4404 4.31428L11.6061 3.48L8.70324 3.54857L9.80038 4.63428C10.8289 5.65142 10.8861 5.68571 10.6461 5.22857C10.509 4.95428 10.4175 4.70285 10.4404 4.68C10.4861 4.64571 11.8232 6.26857 11.8689 6.42857C11.8918 6.48571 11.3661 7.05714 10.7032 7.71999L9.50324 8.90857L9.12609 8.54285C8.77181 8.19999 8.69181 8.17714 7.96038 8.17714H7.16038L9.84609 5.49142Z"></path><path d="M4.93181 12.2343V10.2343H2.30324V14.9886L3.08038 15.7543C3.81181 16.4857 3.88038 16.52 4.39467 16.52H4.93181V14.52L6.93181 16.52H10.0175L8.24609 14.7486C6.48609 12.9886 6.47467 12.9771 6.87467 12.9771C7.24038 12.9771 7.42324 12.84 8.64609 11.6057L10.0175 10.2343H6.93181L4.93181 12.2343Z"></path><path fill-rule="evenodd" clip-rule="evenodd" d="M18.2461 12.6343L15.8461 10.2343H10.7032L7.56038 13.3771L10.7032 16.52H14.3604L18.2461 12.6343ZM10.6461 13.3886L12.1775 11.8343H14.3718L15.149 12.6343L14.0175 13.7771C12.5775 15.2286 12.509 15.2286 11.4232 14.1543L10.6461 13.3886Z"></path></svg>`;

const contentRegExp = /<svg(.*?)>(.*?)<\/svg>/s;
const attrRegExp = /(.*?)="(.*?)"/;
const splitAttrExp = /[\w-]+="[^"]*"/g;

const attributeMap = {
  viewbox: "viewBox",
  class: "className",
};

let instanceId = 0;

function Icon(props) {
  const [, attrs, content] = svg.match(contentRegExp);

  const svgAttributes = {};

  for (const stringAttr of attrs.trim().match(splitAttrExp)) {
    let [, key, value] = stringAttr.match(attrRegExp);
    if (key in attributeMap) key = attributeMap[key];
    svgAttributes[key] = value;
  }

  const [obj, setObj] = useState({ svgAttributes, __html: content });

  // On the client, unique IDs are necessary per instance.
  // We will use the fact that React SSR does not run effects!
  useEffect(() => {
    const ids = svg.matchAll(/id="(.*?)"/gm);
    let html = obj.__html;

    for (const [match, id] of ids) {
      const uniqueID = `${id}-${instanceId}`;
      html = html
        .replace(match, 'id="' + uniqueID + '"')
        .replaceAll(`url(#${id})`, `url(#${uniqueID})`)
        .replaceAll(`"#${id}"`, `"#${uniqueID}"`);
    }

    setObj({ svgAttributes, __html: html });

    instanceId++;
  }, []);

  return (
    <svg
      dangerouslySetInnerHTML={obj}
      {...obj.svgAttributes}
      {...props}
    />
  );
}

export default Object.assign(Icon, { svg });
